import React from 'react';

const LogoSection = () => {
  const logos = [
    { id: 1, src: '/client-logo-1.png', alt: 'LeadEffect', scale: 'normal' },
    { id: 2, src: '/client-logo-2.png', alt: 'Finanzmarkt', scale: 'normal' },
    { id: 3, src: '/saxenhammer.png', alt: 'Saxenhammer & Co.', scale: 'large' },
    { id: 4, src: '/client-logo-4.png', alt: 'RemoteClip', scale: 'normal' },
    { id: 5, src: '/client-logo-5.jpeg', alt: 'GU Energy Group', scale: 'normal' },
    { id: 6, src: '/rigilog.jpg', alt: 'Rigilog AG', scale: 'large' }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
            Vertrauen von Unternehmen, die langfristig denken
          </p>
        </div>
        
        {/* Logo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {logos.map((logo) => (
            <div
              key={logo.id}
              className="flex items-center justify-center p-6 bg-white rounded-lg border border-gray-200 hover:border-primary transition-colors duration-200"
            >
              <div className={`w-full flex items-center justify-center ${
                logo.scale === 'large' ? 'h-20' : 'h-16'
              }`}>
                {logo.src ? (
                  <img 
                    src={logo.src} 
                    alt={logo.alt}
                    className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                  />
                ) : (
                  <span className="text-gray-400 font-medium text-sm">Logo {logo.id}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoSection;